export default __webpack_public_path__ + "static/media/temp stay E4 - Higher Education Visa.4fe65b16.jpg";